import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import MediaUrlField from './MediaUrlField/MediaUrlField';
import HeadlineField from './HeadlineField/HeadlineField';
import DescriptionField from './DescriptionField/DescriptionField';
import ThumbnailField from './ImageUpload/ThumbnailField';
import Wysiwyg from '../shared/Wysiwyg';
import BrandLogoField from './ImageUpload/BrandLogoField';
import materialTheme from '../reactMaterialTheme';
import { useCreativeInput } from '../hooks';

export const NativeDisplayBuilder = props => {
  const [creative, setCreative] = React.useState(props.creative);
  const [behaviors, setBehaviors] = React.useState(creative.behaviors || {});

  const creativeInputProps = useCreativeInput(
    [
      'advertiser',
      'brandLogoUrl',
      'headline',
      'description',
      'name',
      'mediaUrl',
      'isiAutoscroll',
      'isiText'
    ],
    creative,
    setCreative,
    props.CreativeService
  );

  const onThumbnailUrlChange = url => {
    props.CreativeService.set('thumbnailUrl', url);
    setCreative({
      ...creative,
      thumbnailUrl: url
    });
  };

  const handleOgResponse = ogResponse => {
    const newCreative = { ...props.creative, ...ogResponse };
    setCreative(newCreative);
    props.CreativeService.set('headline', newCreative.headline);
    props.CreativeService.set('description', newCreative.description);
    props.CreativeService.set('thumbnailUrl', newCreative.thumbnailUrl);
  };

  const handleToggleCropBehavior = (event, value) => {
    const newValue = value !== undefined ? value : event.target.value;
    const newBehaviors = { ...behaviors, shouldContainThumbnail: newValue };

    setBehaviors(newBehaviors);
    props.CreativeService.setBehavior('shouldContainThumbnail', newValue);
  };

  return (
    <MuiThemeProvider theme={materialTheme}>
      <form className="p2">
        <div className="ad-builder">
          <div className="row">
            <TextField
              {...creativeInputProps.nameProps}
              label="Ad Name"
              className="col-xs-10"
              inputProps={{ 'data-testid': 'creative-name-input' }}
              required
            />
          </div>
          <div className="row mt2">
            <TextField
              {...creativeInputProps.advertiserProps}
              label={
                <label htmlFor={creativeInputProps.advertiserProps.id}>
                  Brand Name
                </label>
              }
              className="col-xs-10"
              onFocus={event => event.target.select()}
              required
            />
          </div>
          <div className="row mt2">
            <BrandLogoField
              logoUrl={creativeInputProps.brandLogoUrlProps.value}
              onLogoUrlChange={creativeInputProps.brandLogoUrlProps.onChange}
            />
          </div>
          <div className="row">
            <MediaUrlField
              mediaUrl={creativeInputProps.mediaUrlProps.value}
              onChange={creativeInputProps.mediaUrlProps.onChange}
              creative={props.creative}
              OpenGraphDataService={props.OpenGraphDataService}
              onOgResponse={handleOgResponse}
              CreativeService={props.CreativeService}
            />
          </div>
          <div className="row">
            <ThumbnailField
              thumbnailUrl={creative.thumbnailUrl}
              onChange={onThumbnailUrlChange}
            />
          </div>
          <div className="row">
            <FormControlLabel
              control={
                <Checkbox
                  checked={behaviors.shouldContainThumbnail}
                  onChange={handleToggleCropBehavior}
                />
              }
              label="Do not crop thumbnail"
            />
          </div>
          <div className="row">
            <HeadlineField
              headline={creativeInputProps.headlineProps.value}
              onChange={creativeInputProps.headlineProps.onChange}
            />
          </div>
          <div className="row">
            <DescriptionField
              description={creativeInputProps.descriptionProps.value}
              onChange={creativeInputProps.descriptionProps.onChange}
            />
          </div>
          {creative.isiText === null ||
          creative.isiText === undefined ? null : (
            <div className="row mt3">
              <div className="form-group inline">
                <h3 className="inline m0 vertical-align-middle">
                  Important Safety Information
                </h3>
                <div className="vertical-align-middle pull-right">
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="isiAutoscroll"
                        checked={!!creativeInputProps.isiAutoscrollProps.value}
                        onChange={
                          creativeInputProps.isiAutoscrollProps.onChange
                        }
                      />
                    }
                    label="Enable Auto-Scrolling"
                  />
                </div>
                <Wysiwyg
                  placeholder="Write your important safety information message"
                  value={creative.isiText}
                  onChange={creativeInputProps.isiTextProps.onChange}
                />
              </div>
            </div>
          )}
        </div>
      </form>
    </MuiThemeProvider>
  );
};

NativeDisplayBuilder.propTypes = {
  $modal: PropTypes.object.isRequired,
  $rootScope: PropTypes.object.isRequired,
  creative: PropTypes.shape({}).isRequired,
  CreativeService: PropTypes.shape({
    set: PropTypes.func.isRequired,
    setBehavior: PropTypes.func
  }).isRequired,
  OpenGraphDataService: PropTypes.object.isRequired
};
